import React, { useContext, useEffect, useRef, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Col, Row } from 'reactstrap'
import './RenderAllTasks.css';
import '../../tabs/Task/CreateTaskModal.css'
import { Badge, Checkbox, Input, message, Select, Spin, Table, TimePicker, Tooltip } from 'antd';
import { SelectedUserAvatar, UserPicker } from '../../common/UserPicker/UserPicker';
import { Option } from 'antd/es/mentions';
import { CaretDownFilled, CaretDownOutlined, CaretLeftOutlined, CaretRightOutlined, CaretUpOutlined, EyeOutlined, FlagFilled } from '@ant-design/icons';
import dayjs from 'dayjs';
import { AppDataRequired } from '../../App';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import swal from "sweetalert";
import { getPriorityValue } from '../HR/TimeClock/Util';
import AddInlineData from './AddInlineData';
import AwsServerService from '../../common/util/AwsServerService';
import { faEye, faGripHorizontal, faGripVertical, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import minusCircle from "../../assets/images/svg/minus-circle.svg";
import CustomTimeSelect from '../../common/CustomTimeSelect/CustomTimeSelect';
import Vector from "../../assets/images/vector.png";
import {
  Modal as AntModal,
  Button as AntButton,
  Select as AntSelect,  
  Button,   
} from "antd";
import { number } from "mathjs";
import _ from 'lodash';
import DependencyModal from "../../tabs/Task/ViewPipelinesTabs/DependencyModal"; 
import { Socket } from "../../Context/AppActions"; 
import AppContext from '../../Context/AppContext';
import { canAccess } from '../../common/util/appUtils';
import { useSelector } from 'react-redux'

export const TaskGroupCardForTemplate = ({ header, data , allPipelineData  ,viewTaskFunction,editData,setEditData,
     setPageRefreshData,allDependeniesData,dropdownTasksDataCache, setSelectedIdsForTemp, selectedIdsForTemp, fromSubtaskTab
    ,allTasksAndSubtasks,setDependencyRefresh,setDummyObj,dummyObj, selectedTable, emptyData, selectedIds, setSelectedIds,setUpdateFlag,viewPipeline}) => {
    const [rowData, setRowData] = useState([]);
    const AppData = useContext(AppContext);
  const { state, dispatch } = AppData || {};
  const { AllUsers } = useContext(AppDataRequired);
    const [sortConfig, setSortConfig] = useState({ key: '', direction: '' }); // State for sorting
    let user = JSON.parse(localStorage.getItem("userinfo")); 
    const accessContext = useSelector(state => state.UserContext.accessContext)
    const canEditPipeline = canAccess(accessContext, "Pipeline Template", "Edit")
    useEffect(e => {
        setRowData(data);
    }, [data])
    const toggleExpandIconOfSubtask=(e)=>{
        e.stopPropagation();
        let arr = e.currentTarget.childNodes;
        let taskId= e.currentTarget.id;
        let arrofsubtasks = document.querySelectorAll(`.${taskId}`);
        arr.forEach(element => {
            if(element.classList.contains("SHOW")){
                element.classList.remove("SHOW")
                element.classList.add("HIDE")
                arrofsubtasks.forEach(subtask=>{
                    // subtask.classList.remove("")
                    subtask.classList.add("HIDEROW")
                })
            }else if(element.classList.contains("HIDE")){
                element.classList.remove("HIDE")
                element.classList.add("SHOW")
                arrofsubtasks.forEach(subtask=>{
                    // subtask.classList.remove("")
                    subtask.classList.remove("HIDEROW")
                })
            }
        });
        console.log(arr);
        
    }

    const [dropdowndata, setdropdownTasksData] = useState();
    const [allDepsData, setAllDepsData] = useState([]);
    useEffect(()=>{
        if(dropdownTasksDataCache && dropdownTasksDataCache.length>0){
            let data=new Map(dropdownTasksDataCache.map((item) => [item.value, item]))
            setdropdownTasksData(data);
        }
    },[dropdownTasksDataCache])
    useEffect(()=>{
        if(allDependeniesData && allDependeniesData.length>0){
            setAllDepsData(allDependeniesData);
        }
    },[allDependeniesData])
    
      const updateTaskData = (data, field, val, type) => {
        type = data.hasOwnProperty("SubTaskROWID") ? "subtask" : "task";
        const data2 = {
          ROWID: type !== "subtask" ? (data.TaskROWID || data.TaskRowId) : data.SubTaskROWID,
          [field]: val || "",
          MODIFIEDBY: user.email_id,
        };
        let updateService;

        if (selectedTable === 'tasks') {
          updateService = type !== "subtask" 
            ? AwsServerService.updateTask 
            : AwsServerService.updateSubtask;
        } else {
          updateService = type !== "subtask" 
            ? AwsServerService.updateTaskInTemplate 
            : AwsServerService.updateSubtaskInTemplate;
        }
        if (type == "subtask") {
          // Find the pipeline containing the matching TaskRowId
          let matchedPipeline = allPipelineData.find(pipeline =>
              pipeline?.Tasks?.some(task => task?.TaskROWID === data?.TaskRowId)
          );
      
          // Extract the PipelineROWID if a matching pipeline is found
          data["PipelineROWID"] = matchedPipeline?.PipelineROWID;
      }
        updateService(data2)
          .then((data) => {
            setPageRefreshData(prev => !prev);
            if(setUpdateFlag){
              setUpdateFlag(prev => !prev);
            }
            dispatch(Socket({ trigger: "refresh_activity", data: '' }))
          })
          .catch(er => console.log("Er", er));
      };

      const sortData = (field) => {
        let direction = 'ascending';
        if (sortConfig.key === field) {
            if (sortConfig.direction === 'ascending') {
                direction = 'descending';
            } else if (sortConfig.direction === 'descending') {
                direction = 'none';
            }
        }
    
        if (direction === 'none') {
            setRowData(data); // Reset to original data
            setSortConfig({ key: '', direction: '' });
        } else {
            const sortedData = [...rowData].sort((a, b) => {
                if (a[field] < b[field]) {
                    return direction === 'ascending' ? -1 : 1;
                }
                if (a[field] > b[field]) {
                    return direction === 'ascending' ? 1 : -1;
                }
                return 0;
            });
            setRowData(sortedData);
            setSortConfig({ key: field, direction });
        }
    };
    
    // Render sorting icons based on the current sort state
    const renderSortIcon = (field) => {
        if (sortConfig.key === field) {
            if (sortConfig.direction === 'ascending') {
                return <CaretUpOutlined />;
            } else if (sortConfig.direction === 'descending') {
                return <CaretDownOutlined />;
            }
        }
        return null; // No icon when not sorted
    };
    const [dependencyLoader,setDependencyLoader] = useState(false);
    const [allDependencies,setAllDependencies]=useState([])
    const modifyDependenciesData=(result,sourceTaskType,ROWID)=>{
      let obj = {
        WaitingOn: [],
        Blocking: []
      }; 
      let allDep=[];
      result.forEach(element=>{
        let waitingObj={};
        let blockingObj={};
        let t={...element}
        if(sourceTaskType==element.STaskType && ROWID==element.SourceTaskId){
          if(element.DependancyType=='WaitingOn'){ 
            waitingObj['ROWID']=element.ROWID
            waitingObj['DependancyType']=element.DependancyType
            waitingObj['CREATEDBY']=element.CREATEDBY
            waitingObj['MODIFIEDBY']=element.MODIFIEDBY
            waitingObj['IsResolved']=element.IsResolved
            waitingObj['SourceDependencyStatus']=element.SourceDependencyStatus
            waitingObj['TargetDependencyStatus']=element.TargetDependencyStatus
            waitingObj['sourceValue']=`${element.STaskType}_${element.SourceTaskId}`
            waitingObj['value']=`${element.TaskType}_${element.TargetTaskId}`
            waitingObj['pipelineName']= element.PipelineName
            obj.WaitingOn.push(waitingObj);
          }else{ 
            blockingObj['ROWID']=element.ROWID
            blockingObj['DependancyType']=element.DependancyType
            blockingObj['CREATEDBY']=element.CREATEDBY
            blockingObj['MODIFIEDBY']=element.MODIFIEDBY
            blockingObj['IsResolved']=element.IsResolved
            blockingObj['SourceDependencyStatus']=element.SourceDependencyStatus
            blockingObj['TargetDependencyStatus']=element.TargetDependencyStatus
            blockingObj['sourceValue']=`${element.STaskType}_${element.SourceTaskId}`
            blockingObj['value']=`${element.TaskType}_${element.TargetTaskId}`
            blockingObj['pipelineName']= element.PipelineName
            obj.Blocking.push(blockingObj);
          }
        }
        t["SourceTaskId"] = t["STaskType"] + "_" + t["SourceTaskId"]
        t["TargetTaskId"] = t["TaskType"] + "_" + t["TargetTaskId"]
        allDep.push(t);
      })
      setAllDependencies(allDep);
      return obj;
    }
    const getAndSetDependencyData=(sourceTaskType,ROWID)=>{
      if(ROWID==undefined||ROWID==null){
        return
      }
      setDependencyLoader(true);
      AwsServerService.getAllTempDependencies().then(res => {
        const result = res.data;
        if (result.length > 0) {
          let obj = modifyDependenciesData(result, sourceTaskType, ROWID);
          setSelectedDependenciesCache(obj);
        } else {
          setSelectedDependenciesCache({ WaitingOn: [], Blocking: [] });
          setAllDependencies([]);
        }
        setDependencyLoader(false);
      }).catch(err=>setDependencyLoader(false)).finally(e=>setDependencyLoader(false))
    }
    const getAllDependenciesForTask = (subtask, ROWID) => { 
      let sourceTaskType = subtask ? "SubTasks" : "Tasks";
      // let ROWID = sourceTaskType == "Tasks" ? data.TaskROWID : data.SubTaskROWID;
      let result=[];
      if(allDependeniesData){
         result = allDependeniesData?.filter((e) => e.SourceTaskId == ROWID && e.STaskType==sourceTaskType);
      }else{
         result = allDepsData?.filter((e) => e.SourceTaskId == ROWID && e.STaskType==sourceTaskType);
      }
      if (result && result.length > 0) {
        let count={blocking:0,waiting:0};
        result.forEach(element=>{
          if(element.DependancyType=='WaitingOn'){
            count.waiting +=1;
            // count.waiting.waitingData.push(element);
          }else{
            count.blocking +=1;
            // count.blocking.blockingData.push(element);
          }
        })
        // let obj = modifyDependenciesData(result, sourceTaskType, ROWID);
        // setSelectedDependenciesCache(obj);
        return { WaitingOn: count.waiting, Blocking: count.blocking, ROWID:ROWID, type:sourceTaskType};
      } else {
        return { WaitingOn: 0, Blocking: 0, ROWID:ROWID, type:sourceTaskType };
      }
    };
      const [selectedDependenciesCache,setSelectedDependenciesCache]=useState({WaitingOn:[], Blocking:[]}) 
      const [dropdowncount,setDropdownCount]=useState({WaitingOn:0, Blocking:0}) 
      const [isDependencyModalOpen,setIsDependencyModalOpen]=useState(false)  
      const viewTaskData=useRef({});
      const [selectedDependencies,setSelectedDependencies]=useState({
        WaitingOn:[],
        Blocking:[]
      });
      useEffect(()=>{  
          let data={...selectedDependenciesCache} 
          setSelectedDependencies(data);  
      },[selectedDependenciesCache])  
        function getOptionsForDropdown(data,selected,viewTaskData){
          let options=[];
          let selectedData={...selected}
          let type=viewTaskData?.hasOwnProperty('SubTaskROWID')?'SubTasks':'Tasks';
          let id=viewTaskData?.hasOwnProperty('SubTaskROWID')?viewTaskData?.SubTaskROWID:viewTaskData?.TaskROWID;
          const valuesToExclude = new Set([
            ...selectedData.Blocking.map(item => item.value),
            ...selectedData.WaitingOn.map(item => item.value),
            `${type}_${id}`
          ]) 
          data.filter(e=>!valuesToExclude.has(e.value)?options.push(e):'')
          return options;
        }
        function openTaskFromDependencies(data){ 
          const [type,id]=data?.value?.split('_');
          if(type=='Tasks'){
            AwsServerService.getTaskByIdFromTemplate(number(id)).then(res=>{ 
              let k=res[0]?.taskInfo||res[0][0]?.taskInfo;
              if(k){ 
                viewTaskFunction(k,"TASK");  
              }
            })  
          }else{
            AwsServerService.getSubTaskBySubTaskIdFromTemplate(number(id)).then(res=>{
              let k=res[0]?.taskInfo || res[0][0]?.taskInfo;
              if(k){ 
                viewTaskFunction(k,"SUBTASK");  
              }
            })  
          }
          // let tasksData={...allTaskAndSubtask}; 
          //   const newData=tasksData[type].get(number(id));
          //   if(newData){
          //     viewTaskFunction(newData,type);
          //   } 
           setIsDependencyModalOpen(false);
        }
        const handleCreateActivity = (Ftype,sourceTaskType, message, ROWID, template,blockRefresh)=>{
          let type=sourceTaskType=='Tasks'?'TASK':'SUBTASK';
          if(template){
            type=sourceTaskType=='Tasks'?'TASKTEMPLATE':'SUBTASKTEMPLATE';
          }
          let payload={
            SourceId:ROWID,
            ActivityType:type,
            Message:message,
            ActivityOwner:user.email_id,
            FilterType:Ftype
          }  
         AwsServerService.createActivity(payload).then(res=>{
          if(!blockRefresh){
            // dispatch(Socket({trigger:"refresh_activity",data:''}))
          }
         }).catch(errMessage=>{
          console.log('Error saving Activity',errMessage);
         })
      }

        const handleSaveDependencies=async (data,deptype)=>{ 
          try {
            setDependencyLoader(true);
            
            let sourceTaskType=viewTaskData.current.hasOwnProperty('SubTaskROWID')?'SubTasks':'Tasks';
            let sourceId=viewTaskData.current.hasOwnProperty('SubTaskROWID')?viewTaskData.current.SubTaskROWID:viewTaskData.current.TaskROWID;
          let isResolvedDependancy = 0;
          let currentStatusOfSourceTask = viewTaskData.current?.TaskFlowObject?.Nodes?.find(k => k.id == viewTaskData.current.TaskStatus);
          let currentStatusOfTargetTask = data.taskData?.TaskFlowObject?.Nodes?.find(k => k.id == data?.taskData.TaskStatus);
          let tempTaskS;
          let tempTaskState;
          let tempTaskSAlt;
          let tempTaskStateAlt;
          if(deptype=="WaitingOn"){
            tempTaskS = data.toStatus;
            tempTaskState = currentStatusOfTargetTask?.data?.state
            tempTaskSAlt = data.thisStatus
            tempTaskStateAlt = currentStatusOfSourceTask?.data?.state;
          }else{
            tempTaskS = data.thisStatus;
            tempTaskState = currentStatusOfSourceTask?.data?.state
            tempTaskSAlt = data.toStatus;
            tempTaskStateAlt = currentStatusOfTargetTask?.data?.state
          }
          if ((tempTaskS == "S" && tempTaskState != "Start") || (tempTaskSAlt == "S" && tempTaskStateAlt != "Start")) {
            isResolvedDependancy = 1;
          } else if ((tempTaskS == "F" && tempTaskState == "Close") || (tempTaskSAlt == "F" && tempTaskStateAlt == "Close")) {
            isResolvedDependancy = 1;
          }
          // -- end -- logic to check already resolved dep 
              const [type, id] = data.value.split('_');
              const payload = {
                TargetTaskId: id,
                STaskType: sourceTaskType,
                SourceTaskId: sourceId,
                TaskType: type,
                DependancyType: deptype,
                IsResolved:isResolvedDependancy,
                PipelineROWID: viewTaskData.current.PipelineROWID,
                CREATEDBY: localStorage.getItem("ZUID"),
                TargetDependencyStatus: data.TargetDependencyStatus,
                SourceDependencyStatus: data.SourceDependencyStatus
              }
              return AwsServerService.createTempDependency(payload).then(async e => {
        
                let selections = [...selectedDependencies[deptype]];
                selections.push({ ...data, ROWID: e.data[0]?.insertId, sourceValue: `${sourceTaskType}_${sourceId}`,CREATEDBY: localStorage.getItem("ZUID") });
                // setSelectedDependenciesCache({
                //   ...selectedDependencies,
                //   [deptype]: selections,
                // })
                let dependencytype = deptype == 'Blocking' ? 'Blocking' : 'Waiting';
                let thisStatus=data.SourceDependencyStatus=='S'?'Start':'Finish';
                let toStatus=data.TargetDependencyStatus=='S'?'Start':'Finish';
                let message = `USER added ${dependencytype} dependency : where ${thisStatus} of this 
                  task is ${dependencytype} ${toStatus} of ${data.value}`
                handleCreateActivity('DEPENDENCY',sourceTaskType, message, sourceId, true, true);
                let typeOfDep = dependencytype == 'Blocking' ? 'WaitingOn' : 'Blocking';
                const reversePayload = {
                  TargetTaskId: sourceId,
                  STaskType: type,
                  SourceTaskId: id,
                  TaskType: sourceTaskType,
                  DependancyType: typeOfDep,
                  IsResolved:isResolvedDependancy,
                  CREATEDBY: localStorage.getItem("ZUID"),
                  TargetDependencyStatus: data.SourceDependencyStatus,
                  SourceDependencyStatus: data.TargetDependencyStatus,
                }
                await AwsServerService.createTempDependency(reversePayload).then(res => {
                  let typ = typeOfDep == 'Blocking' ? 'Blocking' : 'Waiting';
                  let message2 = `USER added ${typ} dependency : where ${toStatus} of this 
                  task is ${typ} ${thisStatus} of ${sourceTaskType}_${sourceId}`
                  handleCreateActivity('DEPENDENCY',type, message2, id,true);
                });
              }).catch(err => swal('Failed', 'Error saving dependency', 'Alert')).finally(e => {
                setDependencyLoader(false);
                getAndSetDependencyData(sourceTaskType, sourceId);
              }); 
            } catch {
             setDependencyLoader(false);
            }
            setDependencyLoader(false);
        } 
        function handleDeleteDependency(e,isWaiting,taskName){
          setDependencyLoader(true);
          let [type,id]=e.value.split('_'); 
          let sourceType=viewTaskData.current.hasOwnProperty('SubTaskROWID')?'SubTasks':'Tasks';
          let sourceId=viewTaskData.current.hasOwnProperty('SubTaskROWID')?viewTaskData.current.SubTaskROWID:viewTaskData.current.TaskROWID;
          
         AwsServerService.deleteTempDependency(sourceId, sourceType, id, type, e.SourceDependencyStatusId, e.TargetDependencyStatusId).then(r => {
        if (isWaiting == 'waiting') {
          let selections = [...selectedDependenciesCache.WaitingOn];
          let data = selections?.filter(t => t.ROWID !== e.ROWID);
          if (data.length == 0) {
            setDropdownCount({ ...dropdowncount, 'WaitingOn': 0 });
          }
          setSelectedDependenciesCache({ ...selectedDependenciesCache, 'WaitingOn': data })
        } else {
          let selections = [...selectedDependencies.Blocking];
          let data = selections?.filter(t => t.ROWID !== e.ROWID);
          if (data.length == 0) {
            setDropdownCount({ ...dropdowncount, 'Blocking': 0 });;
          }
          setSelectedDependenciesCache({ ...selectedDependenciesCache, 'Blocking': data })
        }
        let dependencytype = isWaiting == 'waiting' ? 'Waiting on' : 'Blocking';
        let val = e.value?.split('_');
        let newData = allTasksAndSubtasks[val[0]].get(Number(val[1]));
        let message = `USER removed ${dependencytype} dependency : where ${e.SourceDependencyStatusId == "S" ? "Start" : "Finish"} of this 
            task was ${dependencytype} ${e.TargetDependencyStatusId == "S" ? "Start" : "Finish"} of ${e.value}`
        handleCreateActivity('DEPENDENCY',sourceType, message, sourceId, "template", true);
        let deptype = isWaiting == 'waiting' ? 'Blocking' : 'Waiting on';
        let targetType = newData.hasOwnProperty('SubTaskROWID') ? 'SubTasks' : 'Tasks';
        let targetId = newData.hasOwnProperty('SubTaskROWID') ? newData.SubTaskROWID : newData.TaskROWID;
        let messages = `USER removed ${deptype} dependency : where ${e.TargetDependencyStatusId == "S" ? "Start" : "Finish"} of this 
            task was ${deptype} ${e.SourceDependencyStatusId == "S" ? "Start" : "Finish"} of ${sourceType}_${sourceId}`
        handleCreateActivity('DEPENDENCY',targetType, messages, targetId, "template")
      }   ).catch(e=>{
          console.log(e); 
         }).finally(e => {
         setDependencyLoader(false);
         getAndSetDependencyData(sourceType, sourceId);
         getAllDependenciesForTask(viewTaskData.current?.hasOwnProperty('SubTaskROWID'), viewTaskData.current?.hasOwnProperty('SubTaskROWID') ? viewTaskData.current?.SubTaskROWID : viewTaskData.current?.TaskROWID);
        }).catch(err=>setDependencyLoader(false)).finally(e=>setDependencyLoader(false))
      }

      const DependecyModal = () => {
        const isCreateMode = _.isEmpty(selectedDependenciesCache.Blocking) && _.isEmpty(selectedDependenciesCache.WaitingOn);
        const hasAccess = isCreateMode ? !canAccess(accessContext, "Pipeline Template", "Create") : canAccess(accessContext, "Pipeline Template", "Edit");
        return ( 
            <AntModal
              open={isDependencyModalOpen} 
              wrapClassName={"Add-dependecny-Wrappersss"}
              rootClassName="Add-dependecny-Root-Wrappersss"
              draggable
              title={(selectedDependenciesCache.Blocking.length>0 || selectedDependenciesCache.WaitingOn.length>0)?`Edit Dependency of '${viewTaskData.current.TaskName}'`:`Add Dependency of '${viewTaskData.current.TaskName}'`}
              maskClosable={false}
              width={800}
              className=""
              style={{ bottom: '2rem',right: '9rem', zIndex: "1000" }}
              onCancel={() => {
                setIsDependencyModalOpen(false); 
                viewTaskData.current={};
                setSelectedDependenciesCache({WaitingOn:[], Blocking:[]});
                // let data={...selectedDependenciesCache};
                // setSelectedDependencies(data); 
                setDependencyRefresh(prev=>!prev);
                setDropdownCount({WaitingOn:0,Blocking:0})
              }}
              footer={[<>
              <Button type="primary" 
              style={{cursor: hasAccess ? "pointer" : "not-allowed", opacity: hasAccess ? 1 : 0.6}}
              onClick={()=>{
              if (!hasAccess){message.error("Permission Denied"); return;}
                handleSaveDependencies(selectedDependencies) 
              }}>{_.isEmpty(selectedDependenciesCache.Blocking) && _.isEmpty(selectedDependenciesCache.WaitingOn)?'Save':'Update'}</Button>
              </>]}
            >
              {dependencyLoader &&<div style={{display:'flex',justifyContent:'center',alignItems:'center'}}> <Spin/></div>}
              <div className="stickyDivWrapper"> 
                <div className="sticky-container">
          <DependencyModal allDependencies={allDependencies} setLoader={setDependencyLoader} userOptions={AllUsers} handleSaveDependencies={handleSaveDependencies}
      dropdownTasksDataCache={dropdownTasksDataCache} setDropdownCount={setDropdownCount} openTaskFromDependencies={openTaskFromDependencies}
      getOptionsForDropdown={()=>{return dropdownTasksDataCache}} selectedDependenciesCache={selectedDependenciesCache} handleDeleteDependency={handleDeleteDependency}
      allTasksAndSubtasks={allTasksAndSubtasks} selectedDependencies={selectedDependencies} dropdowncount={dropdowncount}
      getAllDependenciesForTask={(type,id)=>{
        let typ=type?'SubTasks':'Tasks';
        getAndSetDependencyData(typ,id)}} handlecreateactivity={handleCreateActivity}
      filteredDropdownTasksData={dropdownTasksDataCache} openTaskData={viewTaskData.current} taskData={viewTaskData.current} dealSelected={'NoDeal'}
      /></div></div>
            </AntModal>
        );
      };
    const taskHeaders = [
        {
            label: "Task Name",
            field: "TaskName",
            render: (data, field) => {
              return (editData?.length == 0 || data["TaskId"] || data["SubTaskId"] || data["SubTaskROWID"] || data["flag"] ? 
              <Row style={{
                  display: "flex",
                  height: "41px",
                  alignItems:"center",
                  marginLeft: '1.1rem',
                  cursor: "pointer"
              }} sm={12}
              onClick={e=>{
                if(selectedTable=='tasks'){
                if(data?.hasOwnProperty('SubTaskROWID')){
                  AwsServerService.getSubTaskBySubTaskId(data?.SubTaskROWID).then(res=>{
                    let k= res[0].taskInfo; 
                    if(k){ 
                      viewTaskFunction(k,"SUBTASK");  
                    }
                  }) 
                }else{
                  AwsServerService.getTaskById(data?.TaskROWID).then(res=>{
                    let k= res[0].taskInfo; 
                    if(k){ 
                      viewTaskFunction(k,"TASK");  
                    }
                  }) 
                } 
              }else{
                if(data?.hasOwnProperty('SubTaskROWID')){
                  AwsServerService.getSubTaskBySubTaskIdFromTemplate(data?.SubTaskROWID).then(res=>{
                    let k= res[0]?.taskInfo || res[0][0].taskInfo; 
                    if(k){ 
                      viewTaskFunction(k,"SUBTASK");  
                    }
                  }) 
                }else{
                  AwsServerService.getTaskByIdFromTemplate(data?.TaskROWID).then(res=>{
                    let k= res[0]?.taskInfo || res[0][0].taskInfo; 
                    if(k){ 
                      viewTaskFunction(k,"TASK");  
                    }
                  }) 
                } 
              }
            }}
              ><Col id={`TaskId-${data.TaskId}`} className='Expand-Icon-Section' onClick={toggleExpandIconOfSubtask} sm={1}>
                  {data?.SubTasks?.length>0 && <><CaretRightOutlined className='LEFT SHOW'/><CaretDownOutlined className='RIGHT HIDE' /></>}
                  </Col>
                  <Col 
                  style={{
                      display: "flex",
                      flexDirection: "row",
                      "align-items": "center",
                      gap: "10px",
                    }}>
                  {/* <div>{data?.PipelinePosition}.{data?.Position}</div> */}
                  <Tooltip color="rgb(54 54 54)" placement="top" title={data[field]}><span className='Elipsis-Class' style={{width:"150px"}}>{data[field]}</span></Tooltip>
                  <Tooltip color="rgb(54 54 54)" placement="top" title={`
                ${data.deps.Blocking > 0 ? `Blocking: ${data.deps.Blocking}` : ''} 
                ${data.deps.WaitingOn > 0 ? `Waiting: ${data.deps.WaitingOn}` : ''}
              `}> 
                  <div
              className="dependencyicon"
              onClick={(e) => {
                e.stopPropagation(); 
                viewTaskData.current=data; 
                setIsDependencyModalOpen(true);
                // setSelectedDependenciesCache(data.deps);
                getAndSetDependencyData(data.deps.type,data.deps.ROWID);
              }}
              style={data?.deps.Blocking > 0 ||
                data?.deps.WaitingOn > 0 ? {width:"2em"} : {width: "0px"}}
            >
              {data?.deps.Blocking > 0 &&
              data?.deps.WaitingOn > 0 ? (
                <img
                  className="minus-circle-v"
                  src={minusCircle}
                  onClick={() => {}}
                />
              ) : data?.deps.Blocking > 0 &&
                data?.deps.WaitingOn == 0 ? (
                <FontAwesomeIcon
                  onClick={() => {}}
                  icon={faMinusCircle}
                  color={"#f40600"}
                />
              ) : data?.deps.Blocking == 0 &&
                data?.deps.WaitingOn > 0 ? (
                <FontAwesomeIcon
                  onClick={() => {}}
                  icon={faMinusCircle}
                  color={"#FFA500"}
                />
              ) : (
                <></>
              )}
                </div>
                </Tooltip>
            {data?.SubTasks?.length > 0 ? (
              <div 
              onClick={(e)=>{
                e.stopPropagation();
                let classes = e.currentTarget.id;
                if(classes){
                  document.getElementById(classes).click();
                }                    
              }} 
              style={{width: "1rem"}} 
              id={`TaskId-${data.TaskId}`}
              >
              <Badge
                color="#7a7a7a"
                count={data?.SubTasks?.length}
                className="subtask-badge"
                size="small"
                offset={[2, 0]}
              >
                <img src={Vector} alt="subtask-icon" className="subtask-icon" />
              </Badge>
              </div>
            ) : (
              <></>
            )}
                  </Col>
              </Row>
              :
              <Input variant='borderless' value={editData ? editData?.TaskName : ""} style={{maxWidth:"18rem",marginLeft:'1rem', background:"#fff", marginTop:"2px"}} onChange={(e)=>{setEditData({...editData, TaskName : (e.target.value)?.trimStart()?.replace(/[^0-9a-zA-Z\s()]/g, "")})}}/>
          );
          }
        },
        {
            label: "Assignee",
            field: "Assignee",
            render: (data, field) => {
                let assignee = data[field];
                return (editData?.length == 0 || data["TaskId"] || data["SubTaskId"] || data["SubTaskROWID"] || data["flag"] ? 
                <UserPicker 
                  open={!canEditPipeline ? false : undefined}
                  rootClassName={"table-dropdown"} 
                  className={"No-Border"} 
                  values={assignee} 
                  mode="multiple" 
                  onChange={e => {
                    updateTaskData(data,"Assignee",e)
                }} 
                />
            :
                <UserPicker
                  open={!canEditPipeline ? false : undefined}
                  rootClassName={"table-dropdown"}
                  className={"No-Border"} 
                  values={editData["Assignee"] ? editData["Assignee"] : ""} 
                  mode="multiple" 
                  onChange={e => {
                    let temp={...editData}
                        temp["Assignee"]=e;
                        // console.log(temp);
                        setEditData(temp);
                    }} 
                  placeholder={"Select Option"}
                  onClear={()=> setEditData({ ...editData, Assignee: "" })}
                />
            )
            }
        },
        {
            label: "Project Manager",
            field: "Supervisor",
            render: (data, field) => {
                let Supervisor = data[field];
                return (editData?.length == 0 || data["TaskId"] || data["SubTaskId"] || data["SubTaskROWID"] || data["flag"] ? 
                <UserPicker 
                  open={!canEditPipeline ? false : undefined}
                  rootClassName={"table-dropdown"}
                  className={"No-Border"} 
                  values={Supervisor} 
                  mode="" 
                  onChange={(e) => {
                    updateTaskData(data,"Supervisor",e)
                  }} 
                  placeholder={"Select Option"}
                />
            :
                <UserPicker 
                  open={!canEditPipeline ? false : undefined}
                  rootClassName={"table-dropdown"} 
                  className={"No-Border"} 
                  values={editData["Supervisor"] ? editData["Supervisor"] : ""} 
                  mode="" 
                  onChange={(e, data) => {
                      let temp={...editData}
                          temp["Supervisor"]=e;
                          // console.log(temp);
                          setEditData(temp);
                  }} 
                  placeholder={"Select Option"}
                  onClear={()=> { 
                    setEditData({ ...editData, Supervisor: "" })
                  }}
                />
            )
            }
        },
        // {
        //     label: "Description",
        //     field: "TaskDescription",
        //     render: (data, field) => {
        //         let description = data[field];
        //         return <span title={description} className='Elipsis-Class' style={{width:"400px"}}>{description}</span>;
        //     }
        // },
        {
            label: "Priority",
            field: "Priority",
            render: (data, field) => {
                // return data[field];
                return (editData?.length == 0 || data["TaskId"] || data["SubTaskId"] || data["SubTaskROWID"] || data["flag"] ? 
                  <Tooltip color="rgb(54 54 54)" placement="top" title={data[field]}>
                    <Select className='No-Border priority-icon' name="Priority" placeholder="Select an option" style={{ width: 200 }}
                    value={data[field] ? data[field] : "Not Set"}
                    disabled={!canEditPipeline}
                    open={!canEditPipeline ? false : undefined}
                    onChange={(val) => {
                      updateTaskData(data,"Priority",val)
                    }}
                    // suffixIcon={<CaretDownFilled />}
                    rootClassName="table-dropdown"
                    dropdownRender={(menu) => (
                        <>
                          {menu}
                        </>
                      )}
                      optionLabelProp="icon"
                      title={data[field]}
                      onClear={()=> updateTaskData(data,"Priority","")}
                >
                    <Option value="Not Set" icon={<FlagFilled style={{ color: getPriorityValue("Not Set") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("Not Set") }} /> Not Set
                    </Option>
                    <Option value="Low" icon={<FlagFilled style={{ color: getPriorityValue("Low") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("Low") }} /> Low
                    </Option>
                    <Option value="Medium" icon={<FlagFilled style={{ color: getPriorityValue("Medium") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("Medium") }} /> Medium
                    </Option>
                    <Option value="High" icon={<FlagFilled style={{ color: getPriorityValue("High") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("High") }} /> High
                    </Option>
                </Select></Tooltip>
                :
                <Tooltip color="rgb(54 54 54)" placement="top" title={editData[field]}>
                  <Select className='No-Border priority-icon' name="Priority" placeholder="Select an option" style={{ width: 200 }}
                    value={editData[field] ? editData[field] : "Not Set"}
                    disabled={!canEditPipeline}
                    open={!canEditPipeline ? false : undefined}
                    onChange={(val) => {
                        let temp={...editData}
                        temp["Priority"]=val;
                        // console.log(temp);
                        setEditData(temp)
                    }}
                    // suffixIcon={<CaretDownFilled />}
                    rootClassName="table-dropdown"
                    dropdownRender={(menu) => (
                        <>
                          {menu}
                        </>
                      )}
                      optionLabelProp="icon"
                >
                    <Option value="Not Set" icon={<FlagFilled style={{ color: getPriorityValue("Not Set") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("Not Set") }} /> Not Set
                    </Option>
                    <Option value="Low" icon={<FlagFilled style={{ color: getPriorityValue("Low") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("Low") }} /> Low
                    </Option>
                    <Option value="Medium" icon={<FlagFilled style={{ color: getPriorityValue("Medium") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("Medium") }} /> Medium
                    </Option>
                    <Option value="High" icon={<FlagFilled style={{ color: getPriorityValue("High") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("High") }} /> High
                    </Option>
                </Select>
                </Tooltip>
            )
            }
        },
        {
            label: "Time Estimate",
            field: "TimeEstimate",
            render: (data, field) => {
                return (
                    editData?.length == 0 || data["TaskId"] || data["SubTaskId"] || data["SubTaskROWID"] || data["flag"] ? 
             
              <CustomTimeSelect 
                disabled={!canEditPipeline}
                open={!canEditPipeline ? false : undefined}
                rootClassName={"Task-Table-TimePicker"}
                className={(data[field] != "null" && data[field]) ? "Task-Table-TimePicker-Class" : "Task-Table-TimePicker-Class1"}
                placement={"top"}
                taskData={data}
                setTaskData={(time)=>{updateTaskData(data,"TimeEstimate", time)}}
              />
              :
              <CustomTimeSelect 
                disabled={!canEditPipeline}
                open={!canEditPipeline ? false : undefined}
                rootClassName={"Task-Table-TimePicker"}
                className={(data[field] != "null" && data[field]) ? "Task-Table-TimePicker-Class" : "Task-Table-TimePicker-Class1"}
                placement={"top"}
                taskData={editData}
                setTaskData={(time)=>{setEditData({...editData, "TimeEstimate" : time})}}
                // setTaskData={(dt)=>{setEditData({...editData, "TimeEstimate" : dt?.TimeEstimate})}}
              />
            );
            }
        },
        {
              label: "Sequence No.",
              field: "Position",
              render: (data, field)=>{
              return data?.Position;
              }
        },
        {
            label: "Status",
            field: "Status",
            render: (data, field) => {
                return data[field];
            }
        },
        {
            label: "Pipeline",
            field: "PipelineROWID",
            render: (data, field) => {
              let pipelineROWID = editData?.PipelineROWID || data.PipelineROWID;
              let pipeline = allPipelineData.find(e => e.PipelineROWID == pipelineROWID);
              return pipeline ? pipeline.PipelineName: "N/A";
            }
        },
    ]
    const subTaskHeaders = [
        {
            label: "Task Name",
            field: "TaskName",
            render: (data, field) => {
                return <Row style={{
                    display: "flex",
                    height: "41px", 
                    alignItems:"center",
                    cursor:"pointer"
                }} sm={12}
                onClick={e=>{
                  AwsServerService.getSubTaskBySubTaskIdFromTemplate(data.SubTaskROWID).then(res=>{
                    let k=res[0]?.taskInfo;
                    if(k){ 
                      viewTaskFunction(k,"SUBTASK");  
                    }
                  })  
                }}
                ><Col sm={1}></Col><Col sm={1}></Col>
                <Col
              style={{
                display: "flex",
                flexDirection: "row",
                "align-items": "center",
                // textIndent:'1.2rem',
              }}
            >
            <Tooltip color="rgb(54 54 54)" placement="top" title={data[field]}>
             <span className="Elipsis-Class" style={{ width: "138px" }}>{data[field]}</span>
            </Tooltip>
            <Tooltip color="rgb(54 54 54)" placement="top" title={`
                  ${data.deps.Blocking > 0 ? `Blocking: ${data.deps.Blocking}` : ''} 
                  ${data.deps.WaitingOn > 0 ? `Waiting: ${data.deps.WaitingOn}` : ''}
                `}> 
                <div
                className="dependencyicon"
                onClick={(e) => {
                  e.stopPropagation();
                  let obj=data; 
                  let data2=allTasksAndSubtasks['Tasks']?.get(data?.TaskRowId);
                  obj['PipelineROWID']=data2?.PipelineROWID;
                  viewTaskData.current=obj;
                  setIsDependencyModalOpen(true);
                  // setSelectedDependenciesCache(data.deps); 
                  getAndSetDependencyData(data.deps.type,data.deps.ROWID);
                }}
                style={data?.deps.Blocking > 0 ||
                  data?.deps.WaitingOn > 0 ? {width:"2em"} : {width: "0px"}}
              >
                {data?.deps.Blocking > 0 &&
                data?.deps.WaitingOn > 0 ? (
                  <img
                    className="minus-circle-v"
                    src={minusCircle}
                    onClick={() => {}}
                  />
                ) : data?.deps.Blocking > 0 &&
                  data?.deps.WaitingOn == 0 ? (
                  <FontAwesomeIcon
                    onClick={() => {}}
                    icon={faMinusCircle}
                    color={"#f40600"}
                  />
                ) : data?.deps.Blocking == 0 &&
                  data?.deps.WaitingOn > 0 ? (
                  <FontAwesomeIcon
                    onClick={() => {}}
                    icon={faMinusCircle}
                    color={"#FFA500"}
                  />
                ) : (
                  <></>
                )}
              </div>
              </Tooltip>
                </Col></Row>;
            }
        },
        {
            label: "Assignee",
            field: "Assignee",
            render: (data, field) => {
                let assignee = data[field];
                return <UserPicker 
                          rootClassName={"table-dropdown"} 
                          className={"No-Border"} 
                          values={assignee} 
                          mode="multiple" 
                          onChange={e => {
                            updateTaskData(data,"Assignee",e,"subtask")
                          }}
                          placeholder={"Select Option"} 
                          onClear={()=> updateTaskData(data,"Assignee","","subtask")}
                        />;
            }
        },
        {
            label: "Supervisor",
            field: "Supervisor",
            render: (data, field) => {                
                let Supervisor = data[field];
                return <UserPicker 
                          rootClassName={"table-dropdown"} 
                          className={"No-Border"} 
                          values={Supervisor} 
                          mode="" 
                          onChange={e => {
                            updateTaskData(data,"Supervisor",e,"subtask")   
                          }} 
                          placeholder={"Select Option"}
                          onClear={()=> updateTaskData(data,"Supervisor","","subtask")}
                      />;
            }
        },
        {
            label: "Priority",
            field: "Priority",
            render: (data, field) => {
                // return data[field];
                return <Tooltip color="rgb(54 54 54)" placement="top" title={data[field]}>
                  <Select className='No-Border priority-icon' name="Priority" placeholder="Select an option" style={{ width: 200 }}
                      value={data[field] ? data[field] : "Not Set"}
                      onChange={(val) => {
                        updateTaskData(data,"Priority",val,"subtask")
                      }}
                      // suffixIcon={<CaretDownFilled />}
                      rootClassName="table-dropdown"
                      optionLabelProp="icon"
                      onClear={()=> updateTaskData(data,"Priority","","subtask")}
                    >
                    <Option value="Not Set" icon={<FlagFilled style={{ color: getPriorityValue("Not Set") , height:"100px"}} />}>
                        <FlagFilled style={{ color: getPriorityValue("Not Set") }} /> Not Set
                    </Option>
                    <Option value="Low" icon={<FlagFilled style={{ color: getPriorityValue("Low") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("Low") }} /> Low
                    </Option>
                    <Option value="Medium" icon={<FlagFilled style={{ color: getPriorityValue("Medium") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("Medium") }} /> Medium
                    </Option>
                    <Option value="High" icon={<FlagFilled style={{ color: getPriorityValue("High") }} />}>
                        <FlagFilled style={{ color: getPriorityValue("High") }} /> High
                    </Option>
                </Select>
            </Tooltip>;
            }
        },
        {
            label: "Time Estimate",
            field: "TimeEstimate",
            render: (data, field) => {
                return (
                  <CustomTimeSelect 
                    rootClassName={"Task-Table-TimePicker"}
                    className={(data[field] != "null" && data[field]) ? "Task-Table-TimePicker-Class" : "Task-Table-TimePicker-Class1"}
                    placement={"top"}
                    taskData={data}
                    setTaskData={(time)=>{updateTaskData(data,"TimeEstimate", time)}}
                  />
                )
            }
        },
        {
              label: "Sequence No.",
              field: "Position",
              render: (data, field)=>{
              return '-';
              }
        },
        {
            label: "Status",
            field: "Status",
            render: (data, field) => {
                return data[field];
            }
        },
        {
            label: "Pipeline",
            field: "PipelineROWID",
            render: (data, field,task) => {
                let pipeline = allPipelineData.find(e=>e.PipelineROWID==task.PipelineROWID);
                return pipeline?.PipelineName? pipeline.PipelineName: "N/A";
            }
        },
       
    ]
    const getTabCard = () => {
        // if(groupFilter.group2.name=="Pipeline"){
        //     let pipeline = allPipelineData.find(e=>e.PipelineROWID==header);
        //     return <div className='Group-Titel-Card'>
        //         <span>{pipeline?.PipelineName? pipeline.PipelineName: "N/A"}</span>
        //     </div>
        // }else if(groupFilter.group2.name=="Assignee" || groupFilter.group2.name=="Supervisor"){
        //     let user = AllUsers.find(e=>e.zuid==header);
        //     return <div className='Group-Titel-Card'>
        //         <span>{SelectedUserAvatar({label:user?.full_name,value:user?.zuid})}</span>
        //     </div>
        // }else{
        //     return <div className='Group-Titel-Card'>
        //         <span>{header}</span>
        //     </div>
        // }
        return "Task Name"
    }
    const getTaskHeaders = () => {
        return taskHeaders.map((col, index) => {
            return <th onClick={() => sortData(col.field)}
            className={`${
              index === 0
                ? "min-width-250 task_table_header task-card-title"
                : col.label === "Assignee" ||
                  col.label === "Supervisor" ||
                  col.label === "Priority"                 
                ? "column-header min-width-100" :
                col.label === "Time Estimate" ?
                "column-header min-width-120"
                : "column-header"
            }`}
            style={index == 0 ? {justifyContent:"center"} : {}}
             >{index == 0 ? getTabCard() : col.label}
            {renderSortIcon(col.field)}
            </th>
        })
    }
    const getTaskRow = (data) => {
      return taskHeaders.map((col, index) => {
        const style = {width:'2.5em',display: 'flex',alignItems: 'center', justifyContent: 'center',gap: '1rem',position: 'relative',left: '0'};  
          return <td className={`${col.label=="Action" && "custom-sticky"} ${data?.SubTasks?.length>0 && index==0?"connecting-task-1":""}`}>
            <div style={style}
              className={data?.hasOwnProperty("SubTaskROWID") ? selectedIdsForTemp?.Subtask?.includes(data.SubTaskROWID) ? "" : "checkBoxClass" : selectedIdsForTemp?.Task?.includes(data.TaskROWID)?'':"checkBoxClass" || selectedIdsForTemp?.Task?.includes(data?.id) ? "" : "checkBoxClass"} 
              onClick={(e)=>e.stopPropagation()}>
              {index==0 ? 
              emptyData ?  
              <>
              {!fromSubtaskTab && <FontAwesomeIcon className='Individual-Drag' icon={faGripVertical} style={{ marginLeft: '10px', cursor: 'grab' }}/>}
              <Checkbox 
                    checked={selectedIds.includes(data.id)} 
                    className='Individual-Checkbox'
                    onClick={(e)=>{  
                      if(e.currentTarget.checked){
                        setSelectedIds([...selectedIds , data.id]);
                      }else{
                        let ids=selectedIds.filter(id=>id!=data.id);
                        setSelectedIds(ids);
                      }
                      }}
                  /></>
               :
              data?.hasOwnProperty("SubTaskROWID") ? <>
              {!fromSubtaskTab && <FontAwesomeIcon className='Individual-Drag' icon={faGripVertical} style={{ marginLeft: '10px', cursor: 'grab' }}/>}
              <Checkbox 
                    checked={selectedIdsForTemp?.Subtask?.includes(data.SubTaskROWID)} 
                    className='Individual-Checkbox'
                    onClick={(e)=>{  
                        setSelectedIdsForTemp((prev) => ({
                          ...prev,
                          Subtask: prev?.Subtask?.includes(data.SubTaskROWID)
                            ? prev.Subtask.filter(id => id !== data.SubTaskROWID)  
                            : [...prev.Subtask, data.SubTaskROWID],  
                        }))
                      }}
                  />
                  </>
              :
              <>
              {!fromSubtaskTab && <FontAwesomeIcon className='Individual-Drag' icon={faGripVertical} style={{ marginLeft: '10px', cursor: 'grab' }}/>}
              <Checkbox 
                    checked={selectedIdsForTemp?.Task?.includes(data.TaskROWID) || selectedIdsForTemp?.Task?.includes(data?.id)} 
                    // style={{opacity: '0.7'}}
                    className='Individual-Checkbox'
                    onClick={(e)=>{    
                      let obj = { ...dummyObj };
                      if (e.target.checked) {
                        // Add to dummyObj
                        if (obj[header]) {
                          if (!obj[header].includes(data.TaskROWID)) {
                            obj[header].push(data.TaskROWID);
                          }
                        } else {
                          obj[header] = [data.TaskROWID];
                        }
                      } else {
                        // Remove from dummyObj
                        obj[header] = obj[header]?.filter(id => id !== data.TaskROWID);
                        if (obj[header]?.length === 0) {
                          delete obj[header];
                        }
                      }
                      setDummyObj(obj);
                        setSelectedIdsForTemp((prev) => ({
                          ...prev,
                          Task: prev?.Task?.includes(data.TaskROWID || data?.id)
                            ? prev.Task.filter(id => id !== data.TaskROWID && id !== data?.id)  
                            : [...prev.Task, data.TaskROWID ? data.TaskROWID : data.id],  
                        }))}}
                  /></>
                  :
                  ''}
              </div>
            {col.render(data, col.field)}
            </td>
      })
  }
  const getSubTaskRow = (data,task) => {
    return subTaskHeaders.map((col, index) => {
        return <td style={{marginLeft: '3em'}} className={`${col.label=="Action" && "custom-sticky"} ${index==0?"connecting-task-2":""}`}>
          <div style={{width:'2.5em'}} 
      className={selectedIdsForTemp?.Subtask?.includes(data.SubTaskROWID)?'':"checkBoxClass"} 
      onClick={(e)=>e.stopPropagation()}>
      {index==0 ? 
      <Checkbox 
          checked={selectedIdsForTemp?.Subtask?.includes(data.SubTaskROWID)} 
          className='Individual-Checkbox'
          // style={{opacity: '0.7'}}
          onClick={()=>setSelectedIdsForTemp((prev) => ({
          ...prev,
          Subtask: prev?.Subtask?.includes(data.SubTaskROWID)
            ? prev.Subtask.filter(id => id !== data.SubTaskROWID) 
            : [...prev.Subtask, data.SubTaskROWID], 
        }))}
      />
       :
       ''}
      </div>
          {col.render(data, col.field,task)}
          </td>
    })
}

// const [rowId, setRowId] = useState("");
// const [pipelineRowId, setPipelineRowId] = useState("");
// const [from, setFrom] = useState("");
// const [to, setTo] = useState("");

const updateData=(rowId,pipelineRowId,from,to)=>{
if(rowId != null && pipelineRowId != null && from != null && to != null){
     AwsServerService.updateTaskIndexInTemplate(rowId, pipelineRowId, from, to)
  }
}
//  useEffect(()=>{  
//   if(rowId && pipelineRowId && from && to){
//     AwsServerService.updateTaskIndexInTemplate(rowId, pipelineRowId, from, to)
//       .then(()=>{
//         setRowId("");
//         setPipelineRowId("");
//         setFrom("");
//         setTo("");
//       })
//   }
//   },[rowId, pipelineRowId, from, to]);

    const getSubtaskCollapse = (subtasks, task) => {
        return (subtasks.map((sub, i) => {
            let deps = getAllDependenciesForTask(true, sub.hasOwnProperty("SubTaskROWID")?sub.SubTaskROWID : sub.TaskROWID);
            sub = { ...sub, deps: deps };
            return <tr className={`showCheckBox TaskId-${task.TaskId} HIDEROW`}>{getSubTaskRow(sub,task)}</tr>;
        }))
    }
    return (
        <Col sm={12} className='TaskGroup2Card'>
  {DependecyModal()}
  <Row sm={12}>
    <DragDropContext
     onDragEnd={(result) => { ;
  if (!result.destination) {
    return;
  }
  const draggedRow = rowData[result.source.index];
    const fromRow = rowData[result.source.index];
    const toRow = rowData[result.destination.index];
    const fromPosition = fromRow?.Position;
    const toPosition = toRow?.Position;
    if(fromPosition == toPosition){
      return
    }

  const newData = Array.from(rowData);
  const [removed] = newData.splice(result.source.index, 1);
  newData.splice(result.destination.index, 0, removed);
  
  const updatedDataWithNewPositions = newData.map((row, newIndex) => {
    return {
      ...row,
      Position: newIndex
    };
  });

  setRowData(updatedDataWithNewPositions);
    updateData(draggedRow.TaskROWID, draggedRow.PipelineROWID, fromPosition, toPosition);
    // setRowId(draggedRow.TaskROWID);
    // setPipelineRowId(draggedRow.PipelineROWID);
    // setFrom(fromPosition);
    // setTo(toPosition);
}}
    >
      {/* <Droppable droppableId="table-body-droppable" direction="vertical">
        {(provided) => (
          <table className='table task-table task-content-table table-hover'>
            <thead>
              {getTaskHeaders(header)}
            </thead>
            <tbody
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {rowData?.map((row, index) => {
                let deps = getAllDependenciesForTask(
                  row.hasOwnProperty("SubTaskROWID"),
                  row.hasOwnProperty("SubTaskROWID") ? row.SubTaskROWID : row.TaskROWID
                );
                row = { ...row, deps: deps };

                return (
                  <Draggable
                    key={row.TaskROWID?.toString() || `row-${index}`}
                    draggableId={(row.TaskROWID?.toString() || `row-${index}`)}
                    index={index}
                  >
                    {(provided) => (
                      <React.Fragment key={row.TaskROWID || index}>
                        <tr
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className='showCheckBox'
                        >
                          {getTaskRow(row)}
                        </tr>
                        {row?.SubTasks?.length > 0 && getSubtaskCollapse(row.SubTasks, row)}
                      </React.Fragment>
                    )}
                  </Draggable>
                );
              })}
              {provided.placeholder}
            </tbody>
          </table>
        )}
      </Droppable> */}

      <Droppable isDropDisabled={fromSubtaskTab?true:false} droppableId="table-body-droppable" direction="vertical">
  {(provided) => (
    <table className='table task-table task-content-table table-hover'>
      <thead>
        {getTaskHeaders(header)}
      </thead>
      <tbody
        {...provided.droppableProps}
        ref={provided.innerRef}
      >
        {rowData?.map((row, index) => {
          let deps = getAllDependenciesForTask(
            row.hasOwnProperty("SubTaskROWID"),
            row.hasOwnProperty("SubTaskROWID") ? row.SubTaskROWID : row.TaskROWID
          );
          row = { ...row, deps: deps };

          return (
            <Draggable
              isDragDisabled={fromSubtaskTab?true:false}
              key={row.TaskROWID?.toString() || `row-${index}`}
              draggableId={(row.TaskROWID?.toString() || `row-${index}`)}
              index={index}
            >
              {(provided, snapshot) => {
                const combinedStyle = {
                  ...provided.draggableProps.style,
                  boxShadow: snapshot.isDragging ? "0 4px 8px rgba(0, 0, 0, 0.15)" : undefined,
                  backgroundColor: snapshot.isDragging ? "inherit" : undefined,
                  margin: snapshot.isDragging ? 0 : undefined,
                };

                return (
                  <React.Fragment key={row.TaskROWID || index}>
                    <tr
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className='showCheckBox'
                      style={combinedStyle}
                    >
                      {getTaskRow(row)}
                    </tr>
                    {row?.SubTasks?.length > 0 && getSubtaskCollapse(row.SubTasks, row)}
                  </React.Fragment>
                );
              }}
            </Draggable>
          );
        })}
        {provided.placeholder}
      </tbody>
    </table>
  )}
</Droppable>

    </DragDropContext>
  </Row>
</Col>

    )
}
